import { NotificationProps } from '@progress/kendo-react-notification';
import { Problem } from 'types/entity';
import { ulid } from 'ulid';
import { FpNotificationData } from '.';

/**
 * Notificationに必要なデータを取得する
 * @returns 新規採番されたNotification
 */
const getNotification = (props: {
  type: NotificationProps['type'],
  messageId: string,
  values?: string[],
  error?: Problem,
}): FpNotificationData => ({
  id: ulid(),
  type: props.type,
  messageId: props.messageId,
  values: props.values,
  error: props.error,
});
/**
 * 成功メッセージを取得する
 * @param messageId
 */
export const getSuccessNotification = (messageId: string, values?: string[]): FpNotificationData => getNotification({ type: { style: 'success' }, messageId, values });
/**
 * 警告メッセージを取得する
 * @param messageId
 */
export const getWarningNotification = (messageId: string, values?: string[]): FpNotificationData => getNotification({ type: { style: 'warning' }, messageId, values });
/**
 * エラーメッセージを取得する
 * @param messageId
 */
export const getErrorNotification = (messageId: string, values?: string[]): FpNotificationData => getNotification({ type: { style: 'error' }, messageId, values });
/**
 * APIのエラーメッセージを取得する
 * @param messageId
 */
export const getAPIErrorNotification = (error: Problem | undefined): FpNotificationData => {
  const messageId: string = error?.type || '/error/global/0000';
  // バリデーションエラーの場合のみ値を入れる
  if (error?.status === 400) {
    return getNotification({ type: { style: 'error' }, messageId, error });
  }
  return getNotification({ type: { style: 'error' }, messageId });
};
